<a routerLinkActive="active" routerLink="{{ parentRoute }}{{ tile.slug }}" (click)="sendTrackingTile()">
  <div id="tile">
    <span class="label px-3 py-0 py-md-3">{{ tile.title }}</span>
  </div>
</a>
